import { SHIFT_ALLOWANCE_MIS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';

export const getShiftAllowanceMisBaseURL = () => {
  const servicePath = appendServiceNameToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${servicePath}/api${SHIFT_ALLOWANCE_MIS}`;
  }

  return `${baseUrl}:${appendServicePortToURL(serviceName.PROJECT_MS)}${servicePath}/api${SHIFT_ALLOWANCE_MIS}`;
};
